import { Link } from "gatsby"
import Img from "gatsby-image"
import React from "react"
import styled from "styled-components"
import { H3, P } from "styleguide/components/Text"
import { IconStar } from "styleguide/icons"
import { MetaTags } from "styleguide/page-components/Blog"
import { uiColorToBaseColor } from "styleguide/styles/colors"
import media from "styleguide/styles/media-queries"

const Wrapper = styled.div`
  display: flex;
  margin-bottom: 48px;

  ${media.tablet`
  flex-direction:column;
    margin-bottom: 64px;
  `}
`

const Image = styled(Img)`
  border-radius: 8px;
`

const StyledH3 = styled(H3)`
  margin-bottom: 16px;
  color: ${uiColorToBaseColor("darkestGray")};
  margin-top: 0;
`

const StyledP = styled(P)`
  margin-bottom: 16px;
  margin-top: 0;
`

const StyledLink = styled(Link)`
  min-width: 60%;
  height: auto;
  margin-right: 32px;
  margin-bottom: 16px;

  &:hover {
    text-decoration: none;
  }

  ${media.tablet`
  min-width:100%;
  margin-bottom:24px;
  margin-right:0;
  `}
`

const FeaturedTag = styled.div`
  font-size: 14px;
  line-height: 24px;
  color: ${uiColorToBaseColor("darkestGray")};
  margin-bottom: 16px;
  align-items: center;
  display: flex;
`

const StyledIconStar = styled(IconStar)`
  width: 16px;
  height: 16px;
  margin-right: 8px;
  color: red;
`

const TitleLink = styled(Link)`
  &:hover {
    text-decoration: none;
  }
`

const FeaturedPost = ({
  post: { featuredImage, title, excerpt, categories, date, author },
  slug,
}) => (
  <Wrapper>
    <StyledLink to={slug}>
      {featuredImage && (
        <Image
          fluid={featuredImage.childImageSharp.fluid}
          alt={`${title} - read more`}
          loading="eager"
        />
      )}
    </StyledLink>
    <div>
      <FeaturedTag>
        <StyledIconStar />
        Featured
      </FeaturedTag>
      <TitleLink to={slug}>
        <StyledH3>{title}</StyledH3>
      </TitleLink>
      <StyledP>{excerpt}</StyledP>
      <MetaTags categories={categories} author={author} date={date} />
    </div>
  </Wrapper>
)

export default FeaturedPost
